import StatusOrdersOptions from "../../config/status_order";

export default (value) => {
  const status_order = StatusOrdersOptions.find((item) => {
    return item.value == value;
  });

  return status_order ? status_order.name : null;
};
